import { render, staticRenderFns } from "./BuildView.vue?vue&type=template&id=0139f081&scoped=true"
import script from "./BuildView.vue?vue&type=script&lang=js"
export * from "./BuildView.vue?vue&type=script&lang=js"
import style0 from "./BuildView.vue?vue&type=style&index=0&id=0139f081&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0139f081",
  null
  
)

export default component.exports